import { db } from '../firebase';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  deleteDoc,
  writeBatch,
  serverTimestamp,
} from 'firebase/firestore';
import { toFirestoreDoc, fromFirestoreDoc } from './levelSchema';

const COLLECTION = 'levels';

export async function listLevels() {
  const snap = await getDocs(collection(db, COLLECTION));
  return snap.docs
    .map((d) => fromFirestoreDoc(d.data()))
    .sort((a, b) => a.levelId - b.levelId);
}

export async function getLevel(levelId) {
  const snap = await getDoc(doc(db, COLLECTION, String(levelId)));
  if (!snap.exists()) return null;
  return fromFirestoreDoc(snap.data());
}

export async function saveLevel(level) {
  const payload = { ...toFirestoreDoc(level), updatedAt: serverTimestamp() };
  await setDoc(doc(db, COLLECTION, String(level.levelId)), payload);
}

export async function deleteLevel(levelId) {
  await deleteDoc(doc(db, COLLECTION, String(levelId)));
}

/** Writes many levels in Firestore batches of <=400 (limit is 500 ops/batch). */
export async function saveLevelsBatch(levels) {
  const chunks = [];
  for (let i = 0; i < levels.length; i += 400) chunks.push(levels.slice(i, i + 400));
  for (const chunk of chunks) {
    const batch = writeBatch(db);
    for (const level of chunk) {
      const payload = { ...toFirestoreDoc(level), updatedAt: serverTimestamp() };
      batch.set(doc(db, COLLECTION, String(level.levelId)), payload);
    }
    await batch.commit();
  }
}
